import React, { useEffect, useState } from 'react';
import PageHeading from '../../components/PageHeading/PageHeading';
import { colors } from '../../config/constants';
import { useDispatch } from 'react-redux';
import {
  updateFlashBar,
  updateIsLoading,
  update_breadcrumb,
} from '../../redux/action';
import { handlingNullData } from '../../config/helpers';
import { useParams } from 'react-router-dom';
import { HitCountJobProgressStatus, HitCountStatusMapping } from '../../config/enum';
import instance from '../../service/axiosInstane';
import { flashBarTheme } from '../../config/flashBar';
import Button from '../../components/Button/Button';
import { successMessage } from '../../config/keyword';

type ResultProps = {
  id: string;
  host: string;
  siteUrl: string;
  organizationId: string;
  organizationName: string;
  organizationCode: string;
  totalHitCount: number;
  progressStatus: number;
  siteIndexNumber: string;
  startDate: string;
  endDate: string;
  createdDate: string;
  message: string;
  siteNumber: number;
};

const HitCountJobView = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [hitCountJobDetails, setHitCountJobDetails] = useState<ResultProps>({
    id: '',
    host: '',
    siteUrl: '',
    siteIndexNumber: '',
    organizationId: '',
    organizationName: '',
    organizationCode: '',
    progressStatus: 0,
    totalHitCount: 0,
    createdDate: '',
    startDate: '',
    endDate: '',
    message: '',
    siteNumber: 0,
  });

  useEffect(() => {
    const breadcrumb = [
      { path: '/hitCountJobs', name: 'HitCount Jobs' },
      { path: `/hitCountView`, name: 'HitCount Details' },
    ];
    dispatch(update_breadcrumb(breadcrumb));
    getHitCountJobById();
  }, []);

  const getHitCountJobById = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .get(`/hitcount-jobs/${id}`)
      .then((response) => {
        if (response.status === 200) {
          gotResponse(response.data);
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };

  const gotResponse = (data: ResultProps) => {
    setHitCountJobDetails(data);
    dispatch(updateIsLoading(false));
  };
  const onRestart = async () => {
    dispatch(updateIsLoading(true));
    await instance
      .post(`/hitcount-jobs/${id}/re-start`)
      .then((response) => {
        if (response.status === 200) {
          const obj = {
            isOpen: true,
            message: successMessage.HIT_COUNT_RESTARTED,
            type: flashBarTheme.SUCCESS,
          };
          dispatch(updateFlashBar(obj));
          getHitCountJobById();
        }
      })
      .catch((err) => {
        const obj = {
          isOpen: true,
          message: err.response.data.Message,
          type: flashBarTheme.ERROR,
        };
        dispatch(updateFlashBar(obj));
        dispatch(updateIsLoading(false));
      });
  };
  return (
    <>
      <div className="px-2">
        <PageHeading label="HitCount Details" />
        <div
          className={`bg-white flex flex-col justify-between relative shadow-lg ${colors.primaryText} rounded-sm p-4`}
        >
          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Host</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(hitCountJobDetails?.host)}
              </div>
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Site Url</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(hitCountJobDetails?.siteUrl)}
              </div>
            </div>
          </div>
          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Site Number</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(hitCountJobDetails?.siteNumber)}
              </div>
            </div>
          </div>
          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Organization Name</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(hitCountJobDetails?.organizationName)}
              </div>
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Organization Code</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(hitCountJobDetails?.organizationCode)}
              </div>
            </div>
          </div>
          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Total Hit Count</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(hitCountJobDetails?.totalHitCount)}
              </div>
            </div>
          </div>
          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Created Date</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(hitCountJobDetails?.createdDate)}
              </div>
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Start Date</div>
            <div className="text-black">
              {handlingNullData(hitCountJobDetails?.startDate)}
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">End Date</div>
            <div className="text-black">
              {handlingNullData(hitCountJobDetails?.endDate)}
            </div>
          </div>

          <div className="sm:flex pb-2">
            <div className="sm:w-1/3">Progress Status</div>
            <div className="flex sm:w-2/4">
              <div className="text-black">
                {handlingNullData(
                  HitCountStatusMapping[
                    hitCountJobDetails.progressStatus as HitCountJobProgressStatus
                  ]
                )}
              </div>
            </div>
          </div>

          <div className="sm:flex pb-7">
            <div className="sm:w-1/3">Message</div>
            <div className="text-black">
              {handlingNullData(hitCountJobDetails?.message)}
            </div>
          </div>
          {hitCountJobDetails.progressStatus === HitCountJobProgressStatus.Error && (
            <div className="w-full flex justify-center">
              <Button
                label="Restart"
                type="button"
                buttonType="primary"
                onClick={() => onRestart()}
              />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default HitCountJobView;
